import ChrysothrixPhoto from "../assets/images/lichen/chrysothrix.png";
import FlavoparmeliaPhoto from "../assets/images/lichen/flavoparmelia.png";
import PhaeophysciaPhoto from "../assets/images/lichen/phaeophyscia.png";
import PhysciaPhoto from "../assets/images/lichen/physcia.png";
import XanthomendozaPhoto from "../assets/images/lichen/xanthomendoza.png";

interface LichenGalleryType {
  name: string;
  image: string;
}

export const LICHEN_GALLERY: LichenGalleryType[] = [
  {
    name: "Flavoparmelia caperata & Phaeophyscia pusilloides",
    image: FlavoparmeliaPhoto,
  },
  {
    name: "Phaeophyscia hirsuta, Xanthomendoza ulophyllodes, Candelaria concolor",
    image: PhaeophysciaPhoto,
  },
  {
    name: "Physcia stellaris",
    image: PhysciaPhoto,
  },
  {
    name: "Xanthomendoza ulophyllodes & Candelaria concolor",
    image: XanthomendozaPhoto,
  },
  {
    name: "Chrysothrix caesia & Physcia stellaris",
    image: ChrysothrixPhoto,
  },
];

export type { LichenGalleryType };
